<template>
    <div class="header-search">
        <i @click.stop="click">哈啊哈哈，看了个寂寞。enter password</i>
        <input ref="searchInput" :class="{'show':show}" v-model="searchValue" type="password" @click.stop="" @keyup.enter="search"/>
    </div>
</template>

<script>
    export default {
        name: "articlePassword",
        data(){
          return{
              searchValue: '',
              show: false,
          }
        },
        watch:{
            show(value) {
                if (value) {
                    document.body.addEventListener('click', this.close)
                } else {
                    document.body.removeEventListener('click', this.close)
                }
            }
        },
        methods:{
            search(){
                const that = this;
                if(that.searchValue !== '0306') {
                    that.searchValue = ''
                    return
                }
                that.$emit("showArticle");
                that.close()
            },
            click(){
                this.searchValue = ''
                this.show = !this.show
                if (this.show) {
                    this.$refs.searchInput && this.$refs.searchInput.focus()
                }
            },
            close(){
                this.$refs.searchInput && this.$refs.searchInput.blur()
                this.show = false
            }
        }
    }
</script>

<style scoped lang="less">
.header-search{
    text-align: center;
    position: relative;
    i{
        font-size: 18px;
        position: relative;
        top: 3px;
        cursor: pointer;
    }
    input{
        border:none;
        outline:none;
        overflow: hidden;
        background: transparent;
        height: 30px;
        width: 0;
        transition: .2s all;
        &.show{
            width: 200px;
            margin-left: 10px;
        }
        &:focus{
            border-bottom: 1px solid #8fd0cc;
        }
    }
}
@media (max-width: 960px){
    .header-search{
        margin: 50% auto 0;
    }
}
</style>
